import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { Button } from '../../../../subcomponents/button/button';
import { ButtonColor } from '../../../../subcomponents/button/types/color';
import { Message } from '../../../../subcomponents/message/message';
const b = bemClassBuilder('v-member-password-reset-form-message');
export const MemberPasswordResetFormMessage = props => {
    const { displayText, events } = props;
    return (_jsx(Message, Object.assign({ className: b.block(), title: displayText.invalidPasswordResetCodeErrorTitle, description: displayText.invalidPasswordResetCodeErrorMessage }, { children: _jsx(Button, { color: ButtonColor.Primary, label: displayText.messageActionButtonLabel, onClick: () => { var _a; return (_a = events.onPasswordResetMessageActionButtonClick) === null || _a === void 0 ? void 0 : _a.call(events); } }) })));
};
MemberPasswordResetFormMessage.displayName = 'MemberPasswordResetFormMessage';
